import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { Popover, Overlay, ListGroup } from 'bootstrap';

export default React.createClass({
  displayName: 'PopoverMenu',

  /**
   * Popover Menu Config
   * - icon: What icon do you want to display for the overlay trigger
   * - displayContent: Use this if you do not want an icon
   * - trigger: What type of action triggers the overlay to display
   * - placement: Where the overlay should pop up in regards to the overlay
   *   trigger position.
   * - items: items for the overlay
   */
  propTypes: {
    config: React.PropTypes.object.isRequired,
    grid: React.PropTypes.bool,
    displayContent: React.PropTypes.element,
  },

  getDefaultProps() {
    return {
      grid: false,
    };
  },

  render() {
    //TODO: Add support for text
    //TODO: Add a the row id as the ref instead of generic "target"

    const { config } = this.props;

    return (
      <div className={this.props.className}>
        {this._getDisplayContent()}
        <Overlay
          rootClose
          show={this.props.show}
          onHide={config.get('onHide')}
          placement={config.get('placement')}
          container={document.body}
          target={() => ReactDOM.findDOMNode(this.refs[config.get('id')])}
        >
          {this._getPopover()}
        </Overlay>
      </div>
    );
  },

  _getDisplayContent() {
    const { config, displayContent } = this.props;

    if (displayContent) {
      return (
        <span ref={config.get('id')} onClick={config.get('onClick')}>
          {displayContent}
        </span>
      );
    }

    return (
      <Icon
        ref={config.get('id')}
        name={config.get('icon')}
        size={config.get('iconSize') || 1}
        onClick={config.get('onClick')}
      />
    );
  },

  _getPopover() {
    let clazzName = '';
    if (this.props.grid) clazzName += 'grid-popover-menu-list';

    const { config } = this.props;
    const titleNode = config.get('title') ? (
      <span className="popover-menu-component-title">
        {config.get('title')}
      </span>
    ) : null;

    return (
      <Popover
        id="popover-menu-component"
        className={classNames([this.props.className, 'popover-menu'])}
      >
        {titleNode}
        <div className={clazzName}>
          <ListGroup>{this._getItems()}</ListGroup>
        </div>
      </Popover>
    );
  },

  _getItems() {
    return this.props.config
      .get('items')
      .map((item, id) => this._getLinkItem(item, id));
  },

  _getLinkItem(item, id) {
    return (
      <li
        id={id}
        className={classNames(item.get('classes'), {
          divider: item.get('divider'),
        })}
        onMouseUp={() => this._handleOnClick(item)}
      >
        {item.get('content')}
      </li>
    );
  },

  _handleOnClick(item) {
    const handler = item.get('onClick');
    if (handler) handler();
    this.props.config.get('onHide')();
  },
});
